import React from "react";
import Header from "../components/Header";
import heroBg from "../assets/herobg1.png";

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-[#FBF1EB]">
      <Header />

           <div className="relative w-full h-[350px] sm:h-[300px] overflow-hidden">
        <img
          src={heroBg}
          alt="Export Hero Image"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <section className="w-full py-16 px-4 md:px-12 lg:px-24 bg-[#FBF1EB]">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p className="mb-4">
          At Synergy Innovative Enterprises, your privacy is a priority. As a globally trusted exporter of premium-quality food products—including Spices, Dehydrated Fried Onions, and Onion Powder—we are committed to protecting the personal and business information you share with us.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
        <ul className="list-disc list-inside mb-4">
          <li>Contact information such as name, email, phone number, and address.</li>
          <li>Company details including name, export/import registration, and location.</li>
          <li>Inquiries, feedback, or details provided through our website forms.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
        <ul className="list-disc list-inside mb-4">
          <li>To communicate and respond to inquiries or quote requests.</li>
          <li>To process orders and facilitate international trade operations.</li>
          <li>To improve customer service, website experience, and business transparency.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Information Sharing</h2>
        <p className="mb-4">
          We do not sell or rent your data. We only share necessary details with logistics partners, regulatory authorities, or affiliates directly involved in fulfilling your order or request.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
        <p className="mb-4">
          Our infrastructure includes modern security practices to ensure that your information is stored and transmitted securely.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
        <p className="mb-4">
          You may contact us to review, correct, or delete your personal information. We respect your rights to privacy and data protection under applicable laws.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Cookies</h2>
        <p className="mb-4">
          We may use cookies for analytics and enhanced website functionality. You can manage cookie preferences through your browser settings.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact Us</h2>
        <p className="mb-4">
          For questions regarding this Privacy Policy, please contact:
        </p>
        <p className="mb-1">📧 Email: info@synergyexports.com</p>
        {/* <p className="mb-1">📞 Phone: +91-XXXX-XXXXXX</p> */}
        <a href="tel:+919356936283" className="mb-1">
                 📞 +91 9356936283
                </a>
        <p className="mb-1">🌐 Website: www.synergyexports.com</p>
      </section>
    </main>
  );
}
